/**
 * The analytics opt-out, on its own so a reader does not pull in the Amplitude
 * SDK just to ask the question. Two things honour it: Amplitude (amplitude.ts)
 * and Mucka's own screen-time tracker (src/lib/usage-time/tracker.ts) — the
 * Settings copy promises "turn this off and nothing is sent from this device",
 * and that has to stay true of both.
 */

/** localStorage key a settings toggle can flip to opt a user out. */
export const ANALYTICS_OPTOUT_KEY = 'mucka_analytics_optout';

/**
 * Respect Do-Not-Track and a local opt-out flag. Honouring DNT is part of the
 * consent story in the plan (§5) — a DNT browser never gets initialised, so
 * no events are ever sent for it.
 */
export function hasOptedOut(): boolean {
  if (typeof window === 'undefined') return true;
  const dnt =
    navigator.doNotTrack === '1' ||
    // legacy vendor-prefixed flags, still seen in some WebViews
    (window as unknown as { doNotTrack?: string }).doNotTrack === '1' ||
    (navigator as unknown as { msDoNotTrack?: string }).msDoNotTrack === '1';
  if (dnt) return true;
  try {
    return window.localStorage.getItem(ANALYTICS_OPTOUT_KEY) === '1';
  } catch {
    return false; // private-mode localStorage throw → treat as opted in
  }
}
